export const ExperienceData = [
  {
    title: 'React & Django Developer',
    detail:
      'BigCommerce is the most trusted commerce solution provider. I worked on thier React & Django project.',
    image: process.env.PUBLIC_URL + '/images/bicommerce.png',
    progress: 'BigCommerce, USA',
    time: 'Started: 08.2022 - Ended: 10.2022',
  },
  {
    title: 'Full-Stack Developer',
    detail:
      'Roles: Frontend(ReactJS), Backend(Serverless AWS Lambda) and Deploymnent on server',
    image: process.env.PUBLIC_URL + '/images/eye.jpeg',
    progress: 'EyeControl Company, Israel',
    time: 'Started: 08.2022 - Ended: 10.2022',
  },
  {
    title: 'Director of Engineering for Django | Project Manager',
    detail:
      'A platform for Blockchain based decentralized applications and smart contracts.',
    image: process.env.PUBLIC_URL + '/images/thenewboston.png',
    progress: 'Thenewboston, USA',
    time: 'Started: Nov 13, 2021 - Ended: Jan 28, 2022',
  },
  {
    title: 'Wordpress Developer Role',
    detail:
      'Power Energy Compnay, Providing Energy solutions to thier customers.',
    image: process.env.PUBLIC_URL + '/images/power.png',
    progress: 'Alset Power Company, USA',
    time: 'Started: Nov 9, 2020 -  Ended Feb 11.2021',
  },


]
